import {Button, TextField} from '@material-ui/core';
import {Input, Container} from '@material-ui/core';
import React, {useContext, useState} from 'react';
import {FirebaseContext} from '../../Firebase';
import ReactGoogleSlides from 'react-google-slides';
import {RespDatagrid} from '../../RespDatagrid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

// SESSION 2
const Session2 = () => {
  const firebase = useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = useState(0);
  const [CR, setCR] = useState(false);
  const [response, setResponse] = useState('');
  // respo control
  const [respDictParfumer, setRespDictParfumer] = useState('');
  const [respDictAlphabet, setRespDictAlphabet] = useState('');
  const [respDictRhino, setRespDictRhino] = useState('');
  const [respDictLiberte, setRespDictLiberte] = useState('');
  const [respDictEduquer, setRespDictEduquer] = useState('');
  // respo test
  const [respEngagement, setRespEngagement] = useState('');
  // Set Session 2 => test 2
  const getT2_test = () => {
    if (group.toString() === 'test_a') {
      return session2_T2A;
    } else if (group.toString() === 'test_b') {
      return session2_T2B;
    } else if (group.toString() === 'test_c') {
      return session2_T2C;
    }
  };
  // session
  function SwitchCase(props) {
    switch (props.value) {
      case 0:
        return Session2_1;
      case 1:
        return slide;
      case 2:
        return group.toString() === 'control' ? session2_C1 : session2_T1;
      case 3:
        return group.toString() === 'control' ? session2_C2 : getT2_test();
      case 4:
        return group.toString() === 'control' ? session2_C3 : session2_T3;
      case 5:
        return session2_T4;
      default:
        return 'Aucun scr à afficher';
    }
  }
  ///////// CONTENUS
  /////////
  const slide = (
    <ReactGoogleSlides
      width={'100%'}
      height={480}
      slidesLink="https://docs.google.com/presentation/d/1NV3mP7FWo-D_0IeQRPqWdMcUyMSU4vLRQY5SP08EH-g"
      position={0}
      showControls
    />
  );

  const Session2_1 = (
    <div>
      <h3>
        Bonjour, et bienvenue dans notre deuxième session. Nous sommes heureux
        de te retrouver !
      </h3>
      <p>
        Pour cette session, nous allons parler de coopération. Tu sais sans
        doute ce que ça veut dire, mais dans la recherche, comment ça se mesure
        ?
      </p>
      <p>Prêt à en savoir plus ?</p>
      <p>
        Clique sur le bouton continuer une fois que tu as bien compris pour
        continuer.
      </p>
    </div>
  );
  const session2_C1 = (
    <div>
      <h3>On va continuer par un jeu : le Jeu du Dictionnaire</h3>
      <p>
        Le dictionnaire, c’est toi ! Tu vas voir 5 mots à l’écran, et tu dois
        écrire une définition de ce mot comme si un enfant plus jeune que toi te
        demandait ce que ces mots veulent dire.
      </p>
      <p>
        Mais attention, tu dois donner ta propre définition sans regarder sur
        Internet, et surtout essayer d’aller le plus vite possible !
      </p>
      <p>
        Clique sur le bouton continuer une fois que tu as bien compris pour
        continuer.
      </p>
    </div>
  );
  const session2_C2 = (
    <div>
      <p>C’est parti, voici tes cinq mots !</p>
    </div>
  );
  const session2_C3 = (
    <div>
      <h2>Bravo!</h2>
      <p>
        Nous avons terminé pour aujourd’hui. N’oublie pas de te reconnecter dans
        quelques jours pour notre prochaine séance.{' '}
      </p>
      <p>Merci pour ta participation !</p>
      <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
    </div>
  );

  ///

  const session2_T1 = (
    <div>
      <p>
        Lors de la première séance, tu as fait la rencontre d’un groupe de
        bénévoles comme toi. Tu avais pris le temps de réfléchir à un mot qui
        représente l’altruisme pour toi. Est-ce que tu t’en souviens ? part.
      </p>
      <p>
        Si tu ne t’en souviens pas, ce n’est pas très grave. Dans ce cas,
        réfléchis à un autre mot qui représente l’altruisme le mieux pour toi,
        et note-le quelque part.
      </p>
    </div>
  );

  const session2_T2A = (
    <div>
      <p>
        Nous sommes heureux de te revoir parmi nous pour soutenir la cause de
        l’écologie ! Il paraît que tu as appris des choses intéressantes sur
        l’altruisme ces derniers jours. Tu as même choisi un mot qui représente
        l’altruisme pour toi.
      </p>
      <p>
        Les autres bénévoles aimeraient savoir comment ce mot peut être relié,
        ou s’appliquer, à la thématique de l’écologie. Dans le cadre de la
        sauvegarde de l’environnement, que veut dire ce mot pour toi ?
      </p>
      <p>Quand tu es prêt(e) à répondre, clique sur « Continuer »</p>
    </div>
  );

  const session2_T2B = (
    <div>
      <p>
        Nous sommes heureux de te revoir parmi nous pour soutenir les personnes
        hospitalisées ! Il paraît que tu as appris des choses intéressantes sur
        l’altruisme ces derniers jours. Tu as même choisi un mot qui représente
        l’altruisme pour toi.
      </p>
      <p>
        Les autres bénévoles aimeraient savoir comment ce mot peut être relié,
        ou s’appliquer, à notre thème de la santé. Dans le cadre du soutien aux
        personnes hospitalisées, que veut dire ce mot pour toi ?
      </p>
      <p>Quand tu es prêt(e) à répondre, clique sur « Continuer »</p>
    </div>
  );

  const session2_T2C = (
    <div>
      <p>
        Nous sommes heureux de te revoir parmi nous pour soutenir les personnes
        affectées par la pauvreté ! Il paraît que tu as appris des choses
        intéressantes sur l’altruisme ces derniers jours. Tu as même choisi un
        mot qui représente l’altruisme pour toi.
      </p>
      <p>
        Les autres bénévoles aimeraient savoir comment ce mot peut être relié,
        ou s’appliquer, à notre thème de la pauvreté. Dans le cadre du soutien
        aux personnes affectées par la pauvreté, que veut dire ce mot pour toi ?
      </p>
      <p>Quand tu es prêt(e) à répondre, clique sur « Continuer »</p>
    </div>
  );

  const session2_T3 = (
    <div>
      <p>
        C’est à toi maintenant d’expliquer aux membres du groupe ce que ce mot
        veut dire pour votre engagement commun en tant que bénévoles.
      </p>
      <p>
        Tu peux rentrer ta réponse ci-dessous, et l’écrire comme si tu leur
        parlais directement. Ta réponse peut être aussi longue que tu le
        souhaites.
      </p>
    </div>
  );

  const session2_T4 = (
    <div>
      <p>
        Merci d’avoir pris le temps d’expliquer le mot que tu avais choisi aux
        autres bénévoles !
      </p>
      <p>
        Nous avons terminé pour aujourd’hui. N’oublie pas de te reconnecter dans
        quelques jours pour notre prochaine séance et de nouvelles actions.
      </p>
      <p>Merci pour ta participation !</p>
      <p>Clique sur le bouton ci-dessous pour quitter la séance. </p>
    </div>
  );
  ///////// END CONTENU
  /////////
  /////////
  /////////

  ///////// RENDER
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        <SwitchCase value={scr} />
        {scr === 1 ? (
          <div style={{textAlign: 'center', width: '100%'}}>
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Comment s’appelle l’inverse de la coopération ?
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="altruisme"
                  control={<Radio />}
                  label="Altruisme"
                />
                <FormControlLabel
                  value="entraide"
                  control={<Radio />}
                  label="Entraide"
                />
                <FormControlLabel
                  value="compétition"
                  control={<Radio />}
                  label="Compétition"
                />
              </RadioGroup>
            </FormControl>
          </div>
        ) : (
          ''
        )}
        {scr === 3 && group.toString() === 'control' && (
          <div>
            <TextField
              multiline
              fullWidth
              id="parfumerTI"
              label="Parfumer"
              variant="outlined"
              value={respDictParfumer}
              onChange={(e) => {
                setRespDictParfumer(e.target.value);
              }}
            />
            <br /> <br />
            <TextField
              multiline
              fullWidth
              id="alphabetTI"
              label="Alphabet"
              variant="outlined"
              value={respDictAlphabet}
              onChange={(e) => {
                setRespDictAlphabet(e.target.value);
              }}
            />
            <br /> <br />
            <TextField
              multiline
              fullWidth
              id="rhinoTI"
              label="Rhinocéros"
              variant="outlined"
              value={respDictRhino}
              onChange={(e) => {
                setRespDictRhino(e.target.value);
              }}
            />
            <br /> <br />
            <TextField
              multiline
              fullWidth
              id="libertTI"
              label="Liberté"
              variant="outlined"
              value={respDictLiberte}
              onChange={(e) => {
                setRespDictLiberte(e.target.value);
              }}
            />
            <br /> <br />
            <TextField
              multiline
              fullWidth
              id="eduquerTI"
              label="Eduquer"
              variant="outlined"
              value={respDictEduquer}
              onChange={(e) => {
                setRespDictEduquer(e.target.value);
              }}
            />
            <br /> <br />
            <p>Clique sur le bouton continuer pour valider tes reponses.</p>
          </div>
        )}

        {scr === 4 &&
          (group.toString() === 'test_a' ||
            group.toString() === 'test_b' ||
            group.toString() === 'test_c') && (
            <div>
              <TextField
                id="outlined-basic"
                label="Ta réponse"
                variant="outlined"
                multiline
                required
                fullWidth
                value={respEngagement}
                onChange={(e) => {
                  setRespEngagement(e.target.value);
                }}
              />
              <p>Quand tu as terminé, clique sur « Continuer ».</p>
            </div>
          )}
      </Container>
      <br />

      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (group.toString() === 'control' && scr === 3) {
            // save control DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session2')
              .add({
                date: now,
                response: response,
                respDictParfumer: respDictParfumer,
                respDictAlphabet: respDictAlphabet,
                respDictRhino: respDictRhino,
                respDictLiberte: respDictLiberte,
                respDictEduquer: respDictEduquer,
              })
              .catch((error) => {
                console.log(error);
              });
            setScr(scr + 1);
          } else if (
            (group.toString() === 'test_a' ||
              group.toString() === 'test_b' ||
              group.toString() === 'test_c') &&
            scr === 4
          ) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session2')
              .add({
                date: now,
                response: response,
                respEngagement:respEngagement
              })
              .catch((error) => {
                console.log(error);
              });
            setScr(scr + 1);
          } else if (
            (group.toString() === 'control' && scr === 4) ||
            scr === 5
          ) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};

export default Session2;
